<template>
    <div>
        <crud-table :actions="actions" show-search hide-create search-placeholder="ابحث برقم عملية الشراء" server-pagination :page-count="purchases.meta.last_page" :current-page="purchases.meta.current_page" :total="purchases.meta.total" :per-page="purchases.meta.per_page" title="عمليات الشراء" :items="purchasesItemsComputed" :headers="headers" @delete="openDeleteDialog" @load="loadMore" @search="search" @reset="reset">
            <template slot="header-actions">
                <div class="ms-4">
                    <v-tooltip transition="fade-transition" bottom max-width="280" color="tooltip" :close-delay="300" open-on-focus>
                        <template v-slot:activator="{on, attrs}">
                            <v-btn :disabled="!purchasesItems || purchasesItems.length === 0" color="success darken-1" depressed v-on="on" v-bind="attrs" @click="exportDialog = true" style="height: 38px">
                                <v-icon size="22" left>mdi-file-export-outline</v-icon>
                                <span>استخراج</span>
                            </v-btn>
                        </template>
                        <span>استخراج إلى ملف إكسيل</span>
                    </v-tooltip>
                </div>
            </template>
        </crud-table>

        <v-dialog v-model="exportDialog" max-width="320" overlay-color="#000" overlay-opacity="0.8">
            <v-card>
                <v-card-title class="strong-text--text mb-1">
                    <v-icon color="green darken-2" right>mdi-file-export-outline</v-icon>
                    استخراج عمليات الشراء
                </v-card-title>
                <v-card-subtitle>استخراج عمليات الشراء إلى ملف إكسيل</v-card-subtitle>
                <v-card-text>
                    <v-alert v-if="searchQuery" dense color="grey darken-1" text>
                        <span class="details-text">سيتم استخراج نتائج عملية البحث فقط</span> <!--  "{{searchQuery}}" -->
                    </v-alert>

                    <v-form class="mb-4">
                        <v-checkbox v-model="exportUserFullData" color="success" label="استخراج بيانات الطالب كاملة" persistent-hint hint="استخراج بيانات الطالب كاملةً وليس الاسم فقط" class="mt-0"></v-checkbox>
                        <v-checkbox v-model="showExportDates" color="success" label="تحديد فترة زمنية" persistent-hint hint="تحديد مدة زمنية (من، إلى) للبيانات المُستخرجة"></v-checkbox>
                        <template v-if="showExportDates">
                            <v-menu ref="fromDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="exportFromDate" clearable label="من يوم (اختياري)" placeholder="فلترة بدءاً من يوم (اختياري)" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details class="mb-3"></v-text-field>
                                </template>
                                <v-date-picker ref="picker" v-model="exportFromDate" locale="ar" :max="today" @change="saveFromDate" color="primary"></v-date-picker>
                            </v-menu>
                            <v-menu ref="toDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="exportToDate" clearable label="إلى يوم (اختياري)" placeholder="فلترة حتى يوم (اختياري)" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details class="mb-3"></v-text-field>
                                </template>
                                <v-date-picker ref="picker" v-model="exportToDate" locale="ar" :max="today" @change="saveToDate" color="primary"></v-date-picker>
                            </v-menu>
                        </template>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pt-0 pb-3">
                    <form class="w-100" method="POST" :action="`${exportUrl}?param=1${searchQuery ? '&query=' + searchQuery : ''}${exportFromDate ? '&from_date=' + exportFromDate : ''}${exportToDate ? '&to_date=' + exportToDate : ''}${exportUserFullData ? '&user_full_data=1' : ''}`">
                        <input type="hidden" name="api_token" :value="apiToken" />
                        <v-btn :disabled="!purchasesItems || purchasesItems.length === 0" block color="green darken-1" depressed dark type="submit" download @click="exportDialog = false">
                            <v-icon left>mdi-download</v-icon>
                            استخراج الملف
                        </v-btn>
                    </form>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <action-dialog v-model="deleteDialog" max-width="420" action="delete" :url="`/purchases/${deletePurchase ? deletePurchase.id : ''}`" title="إلغاء عملية الشراء" subtitle="بعد التأكيد سيتم إلغاء وحذف عملية الشراء تماماً" button-text="تأكيد الإلغاء" button-color="error" success-msg="تم إلغاء عملية الشراء بنجاح" noPadding="true" @sync="deleteItem(deletePurchase.id)">
            <div v-if="deletePurchase">
                <v-alert type="error" icon="mdi-alert-octagon-outline" text class="mb-0">
                    <div class="d-flex medium-text strong-text--text">
                        هل أنت متأكد من إلغاء عملية الشراء رقم #{{deletePurchase.id}}؟
                    </div>
                </v-alert>
            </div>
        </action-dialog>
    </div>
</template>

<script>
import CrudTable from '@/components/default/crud-table'

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    components: {
        CrudTable,
    },
    props: {
        purchases: {},
        exportUrl: {},
    },
    data() {
        const now = new Date();

        return {
            page_url: '/purchases',

            today: now.toISOString().substr(0, 10),

            searchQuery: '',
            exportToDate: '',
            exportFromDate: '',

            exportUserFullData: false,
            showExportDates: false,
            exportDialog: false,

            deleteDialog: false,
            deletePurchase: null,

            purchasesItems: null,

            headers: [
                {
                    text: 'عمليات',
                    value: 'actions',
                    sortable: false
                },
                {
                    text: '#',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                },
                {
                    text: 'الطالب',
                    align: 'center',
                    sortable: false,
                    value: 'userName',
                    color: 'link'
                },
                {
                    text: 'نوع العنصر',
                    align: 'center',
                    sortable: false,
                    value: 'purchasable_type',

                    chip: true,
                    chipFunction: (method)=>{
                        if (method === 'App\\Lecture'){
                            return {text: 'محاضرة', color: 'blue darken-4', icon: 'mdi-clipboard-play-outline', filled: true,}
                        }else if (method === 'App\\Course'){
                            return {text: 'دورة', color: 'orange darken-2', icon: 'mdi-play-box-outline', filled: true,}
                        }
                    },
                },
                {
                    text: 'العنصر',
                    align: 'center',
                    sortable: false,
                    value: 'purchasableName',
                    button: 'purchasableUrl',
                    color: 'link'
                },
                {
                    text: 'طريقة الدفع',
                    align: 'center',
                    sortable: false,
                    value: 'purchase_method',

                    chip: true,
                    chipFunction: (method)=>{
                        if (method === 'admin'){
                            return {text: 'اﻹدارة', color: 'indigo', icon: 'mdi-briefcase-account-outline'}
                        }else if (method === 'teacher'){
                            return {text: 'المعلم', color: 'indigo', icon: 'mdi-account-tie-outline'}
                        }else if (method === 'systemApi'){
                            return {text: 'System API', color: 'black', icon: 'mdi-server-network-outline'}
                        }else if (method === 'payCard'){
                            return {text: 'بطاقة دفع', color: 'success', icon: 'mdi-credit-card-outline'}
                        }else if (method === 'wallet'){
                            return {text: 'المحفظة', color: 'orange darken-2', icon: 'mdi-wallet'}
                        }else if (method === 'free'){
                            return {text: 'عنصر مجاني', color: 'deep-purple accent-4', icon: 'mdi-star-four-points-outline'}
                        }
                    },
                },
                {
                    text: 'المبلغ المدفوع',
                    align: 'center',
                    sortable: false,
                    value: 'paidComputed',
                },
                {
                    text: 'بطاقة الدفع',
                    align: 'center',
                    sortable: false,
                    value: 'payCardSerial',
                    color: 'link'
                },
                /* {
                    text: 'الحالة',
                    align: 'center',
                    sortable: false,
                    value: 'status',
                }, */

                {
                    text: 'تاريخ العملية',
                    value: 'created_at',
                    time: true,
                    align: 'center',
                    sortable: false,
                },
            ],
        }
    },
    computed: {
        apiToken(){
            return window.axios.defaults.headers.common['Authorization'].split('Bearer ')[1];
        },
        purchasesItemsComputed(){
            return this.purchasesItems.map(purchase=>{
                const method = purchase.purchase_method === 'admin' ? 'اﻹدارة' : (purchase.purchase_method === 'payCard' ? 'بطاقة دفع' : (purchase.purchase_method === 'free' ? 'مجاناً' : (purchase.purchase_method === 'wallet' ? 'دفع بالمحفظة' : purchase.purchase_method)))
                const purchasableName = purchase.purchasable ? (purchase.purchasable_type === 'App\\Lecture' ? purchase.purchasable.full_name : (purchase.purchasable.name ? purchase.purchasable.name : purchase.purchasable )) : null;
                const purchasableUrl = purchase.purchasable ? (purchase.purchasable_type === 'App\\Lecture' ? `/lectures/${purchase.purchasable.id}` : (purchase.purchasable_type === 'App\\Course' ? `/courses/${purchase.purchasable.id}` : null)) : null;
                return {
                    ...purchase,
                    method,
                    userName: purchase.user ? purchase.user.name : '',
                    // userUrl: purchase.user ? `/users/${purchase.user.id}` : null,
                    payCardSerial: purchase.payCard ? purchase.payCard.serial + '#' : '___',
                    purchasableName,
                    purchasableUrl,
                    paidComputed: purchase.paid_computed || purchase.paid_computed === 0 ? this.moneyFormat(purchase.paid_computed, false) : '__',
                }
            });
        },
        actions(){
            let actions = [
                // {name: 'edit', text: 'تعديل', icon: 'mdi-pencil'},
                // {name: 'delete', text: 'إلغاء العملية', icon: 'mdi-close-octagon-outline', color: 'error'},
            ];
            return actions;
        },
        ...GlobalComputed,
    },
    watch: {
        purchases(purchases){
            this.purchasesItems = purchases.data;
        },
    },
    methods: {
        ...GlobalMethods,
        
        loadMore(payload){
            const page = payload.page;
            this.$emit('loadMore', page);
        },
        search(query){
            this.$emit('search', query);
            this.searchQuery = query;
        },
        reset(){
            this.$emit('reset');
            this.searchQuery = null;
        },

        addItems(data){
            const items = data.data ? data.data : data;
            this.purchasesItems.unshift(...items);
        },
        syncItem(newItem){
            this.purchasesItems = this.purchasesItems.map(item=>{
                if (item.id === newItem.id){
                    return Object.assign(item, newItem);
                }
                return item;
            })
        },
        deleteItem(id){
            this.purchasesItems = this.purchasesItems.filter(item=>{
                return item.id !== id;
            })
        },
        editAction(){

        },
        openDeleteDialog(purchase){
            this.deleteDialog = true;
            this.deletePurchase = purchase;
        },
        saveFromDate(date){
            this.$refs.fromDateMenu.save(date);
        },
        saveToDate(date){
            this.$refs.toDateMenu.save(date);
        },
    },
    mounted(){
        
    },
    created(){
        this.purchasesItems = this.purchases.data;
    }
}

</script>
